import { useEffect } from "react";
import { applyWindowGlobals } from "../lib/bootConfig";
import { initProtonWidget } from "../lib/protonWidget";

/** Chat flutuante PROton — injeta FAB/drawer no document.body (DOM original). */
export function ProtonWidget() {
  useEffect(() => {
    applyWindowGlobals();
    initProtonWidget();
  }, []);
  return null;
}
